import React from 'react'
import classes from "./LoginBanner.module.scss";
import ImgIntro from "../../../assets/images/ImgLoginIntro.png"
import { useTranslation } from 'react-i18next';
//Componente banner com a imagem da tela de login
const LoginBanner = () => {
    const { t } = useTranslation();
    return (
        <div className={classes.Banner}>
            <img src={ImgIntro} alt="" className={classes.ImgBanner} />
            <h1 className={classes.BannerTitle}>{t("global.welcome_to_audioFoco")}</h1>
            <p className={classes.BannerSubtitle}>{t("global.artificial_intelligence_to_train_the_system")} <br />{t("global.cognitive_auditory")}</p>
        </div>
    )
}

export default LoginBanner
